import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function SolutionReveal() {
  return <section className="border-y border-dark-border bg-dark-card px-4 py-20" data-id="element-181">
      <div className="mx-auto max-w-4xl text-center" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-183">
          <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-gold/10 text-2xl" data-id="element-184">
            ★
          </span>
          <h2 className="mt-5 font-serif text-3xl font-bold sm:text-4xl" data-id="element-185">
            El sistema más completo de Historia para el aula de habla hispana
          </h2>
          <p className="mt-4 text-lg font-bold text-gold-gradient" data-id="element-186">
            Mega Pack Historia 360
          </p>
          <p className="mt-3 text-gray-300" data-id="element-187">
            8 tomos · 4 bonos estratégicos · Todo listo para usar desde hoy.
          </p>
        </motion.div>

        <div className="mt-10 grid gap-6 text-left md:grid-cols-2" data-id="element-188">
          <div className="space-y-4 rounded-2xl border border-dark-border bg-black p-6" data-id="element-189">
            {['No es teoría copiada de un manual.', 'No es una colección de actividades sueltas.', 'No es material que tengas que adaptar entero.'].map(text => <p className="flex gap-3 text-sm text-gray-400" key={text} data-id="element-190">
                <X size={18} className="shrink-0 text-red-500" data-id="element-191" />
                {text}
              </p>)}
          </div>

          <div className="rounded-2xl border border-gold/30 bg-gold/10 p-6" data-id="element-192">
            <p className="flex gap-3 font-medium leading-relaxed" data-id="element-193">
              <Check size={20} className="shrink-0 text-gold" data-id="element-194" />
              Es un sistema para que entres al aula con confianza y dictes
              clases que de verdad enseñen a pensar históricamente.
            </p>
          </div>
        </div>
      </div>
    </section>;
}